var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "scroll-number" },
    [
      _vm._l(_vm.numbers, function (val, index) {
        return [
          !_vm.isNumber(val)
            ? _c(
                "div",
                {
                  key: "char-" + index,
                  staticClass: "digit",
                  style: _vm.itemStyle,
                },
                [_c("span", [_vm._v(_vm._s(val))])]
              )
            : _c("ScrollNumberItem", {
                key: _vm.getIndex(_vm.numbers, index),
                ref: "scrollItem",
                refInFor: true,
                attrs: {
                  height: _vm.height,
                  inHeight: _vm.inHeight,
                  direction: _vm.direction,
                  itemStyle: _vm.itemStyle,
                  transitionTime: _vm.transitionTime,
                },
              }),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }